import { FC, useState } from 'react';
import { IconButton, InputAdornment } from '@mui/material';
import { useFormikContext } from 'formik';
import { TextInput, TextInputProps } from './text-input.tsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';

export const PasswordInput: FC<TextInputProps> = (props) => {
  const [showPassword, setShowPassword] = useState(false);
  const { isSubmitting } = useFormikContext<any>();
  return (
    <TextInput
      {...props}
      type={!isSubmitting && showPassword ? 'text' : 'password'}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              disabled={isSubmitting}
              aria-label="toggle password visibility"
              onClick={() => setShowPassword(!showPassword)}
              onMouseDown={(event) => event.preventDefault()}
              edge="end"
            >
              {!isSubmitting && showPassword ? <FontAwesomeIcon icon={faEyeSlash} /> : <FontAwesomeIcon icon={faEye} />}
            </IconButton>
          </InputAdornment>
        )
      }}
    />
  );
};
